import React from 'react';
import styled from '@emotion/styled';
const USLink = styled.a `
  border: none;
  background: none;
  font-size: inherit;
  font-family: inherit;
  text-align: inherit;
  color: inherit;
  padding: 0;
  margin: 0;

  &:link {
    text-decoration: none !important;
  }

  &:visited {
    text-decoration: none !important;
  }

  &:hover {
    text-decoration: none !important;
  }

  &:active {
    text-decoration: none !important;
  }
`;
/**
 *
 */
const UnstyledLink = ({ children, ...rest }) => <USLink {...rest}>{children}</USLink>;
export default UnstyledLink;
